/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react'
import { KTSVG } from '../../../../_metronic/helpers'
import './VisaListRecordCount.css'
import { object } from 'yup'



type Props = {
    className?: string
    heading?: string
    total_count?: string
    route_heading?: string
    data?: any
    name?: string
    count?: any
    followup_yes?: number
    followup_past_active?: number


    followup_no?: number
    followup_active?: number
    followup_deactive?: number
    today_followup?: number
    today_task?: number
    filter?: any
}

const VisaListFollowupRecord: React.FC<Props> = ({ className, heading, count, data, followup_yes, followup_past_active, followup_no, followup_active, followup_deactive, today_followup, today_task, filter, name }) => {
    function removeEmptyPairs(filter: any) {
        if (filter === undefined || filter === null) {
            return '';
        }
        const pairs = filter.split('&');
        // console.log('pair',pairs)
        const nonEmptyPairs = pairs.filter((pair: any) => {
            const [key, value] = pair.split('=');
            return value !== '';
        });
        // console.log('nonempty',nonEmptyPairs)
        const filteredFilter = nonEmptyPairs.join('&');

        return filteredFilter;
    }
    const filteredFilter = removeEmptyPairs(filter);

    const hasMatchingKey = filteredFilter.split('&').some((pair: any) => {
        const [key] = pair.split('=');
        return key === name;
    });
    let newFilteredFilter = filteredFilter;

    if (hasMatchingKey) {
        const pairs = newFilteredFilter.split('&');
        newFilteredFilter = pairs
            .filter((pair: any) => {
                const [key] = pair.split('=');
                return key !== name;
            })
            .join('&');
    }

    const currentPath = window.location.pathname + window.location.search;

    // console.log('originalUrl', currentPath)
    // Function to update the URL with a new query parameter
    const updateURL = (paramName: any, paramValue: any) => {
        if (window.location.search === '') {
            console.log('paramValue', paramValue)
            const currentPath = window.location.pathname + window.location.search;
            const newURL = `${currentPath}?${paramName}=${paramValue}`;
            window.open(newURL);
        } else {
            const currentPath = window.location.pathname + window.location.search;
            const newURL = `${currentPath}&${paramName}=${paramValue}`;
            window.open(newURL);
        }
    };

    const handleItemClick = (e: any, obj: any) => {
        e.preventDefault();
        updateURL(name, obj);
    };


    return (
        <div className={`card ${className}`}>
            <div className='card-header border-0'>
                <h3 className='card-title fw-bold text-dark'>{heading}</h3>
                {/* <div className='card-toolbar'>
                    <button
                        type='button'
                        className='btn btn-sm btn-icon btn-color-primary btn-active-light-primary'
                        data-kt-menu-trigger='click'
                        data-kt-menu-placement='bottom-end'
                        data-kt-menu-flip='top-end'
                    >
                        <KTSVG path='/media/icons/duotune/arrows/arrow-up-right-square-fill.svg' className='svg-icon-2' />
                    </button>
                </div> */}
            </div>

            <div className='card-body pt-4 custom-fixed-height'>
                <div >
                    <div className='d-flex align-items-center mb-5 border-bottom border-secondary'>
                        <span className='bullet bullet-vertical h-30px bg-success mb-1'></span>
                        <div className='flex-grow-1 mx-8 '>

                            <a href={currentPath} onClick={(e) => handleItemClick(e, 'yes')} className='text-gray-800 text-hover-primary fw-bold fs-6'>
                                {"Yes"}
                            </a>
                        </div>
                        <span className='fw-bold badge badge-primary d-block me-2'>{followup_yes}</span>

                        {/* <a href={`${process.env.REACT_APP_HOME_PAGE}visafile-management/list?visafollowup=yes&${filteredFilter}`} target='_blank' type='button' className='btn btn-sm btn-icon btn-color-success btn-active-light-success'>
                            <KTSVG path='/media/icons/duotune/general/gen057.svg' className='svg-icon-2' />
                        </a> */}

                        {
                            hasMatchingKey === true ?
                                <a href={`${process.env.REACT_APP_HOME_PAGE}visafile-management/list?${newFilteredFilter}&${name}=yes`} target='_blank' type='button' className='btn btn-sm btn-icon btn-color-success btn-active-light-success'>
                                    <KTSVG path='/media/icons/duotune/general/gen057.svg' className='svg-icon-2' />
                                </a>
                                : <a href={`${process.env.REACT_APP_HOME_PAGE}visafile-management/list?${filteredFilter}&${name}=yes`} target='_blank' type='button' className='btn btn-sm btn-icon btn-color-success btn-active-light-success'>
                                    <KTSVG path='/media/icons/duotune/general/gen057.svg' className='svg-icon-2' />
                                </a>
                        }

                    </div>
                    <div className='d-flex align-items-center mb-5 border-bottom border-secondary'>
                        <span className='bullet bullet-vertical h-30px bg-success mb-1'></span>
                        <div className='flex-grow-1 mx-8 '>

                            <a href={currentPath} onClick={(e) => handleItemClick(e, 'no')} className='text-gray-800 text-hover-primary fw-bold fs-6'>
                                {"No"}
                            </a>
                        </div>
                        <span className='fw-bold badge badge-primary d-block me-2'>{followup_no}</span>

                        {/* <a href={`${process.env.REACT_APP_HOME_PAGE}visafile-management/list?visafollowup=no&${filteredFilter}`} target='_blank' type='button' className='btn btn-sm btn-icon btn-color-success btn-active-light-success'>
                            <KTSVG path='/media/icons/duotune/general/gen057.svg' className='svg-icon-2' />
                        </a> */}
                        {
                            hasMatchingKey === true ?
                                <a href={`${process.env.REACT_APP_HOME_PAGE}visafile-management/list?${newFilteredFilter}&${name}=no`} target='_blank' type='button' className='btn btn-sm btn-icon btn-color-success btn-active-light-success'>
                                    <KTSVG path='/media/icons/duotune/general/gen057.svg' className='svg-icon-2' />
                                </a>
                                : <a href={`${process.env.REACT_APP_HOME_PAGE}visafile-management/list?${filteredFilter}&${name}=no`} target='_blank' type='button' className='btn btn-sm btn-icon btn-color-success btn-active-light-success'>
                                    <KTSVG path='/media/icons/duotune/general/gen057.svg' className='svg-icon-2' />
                                </a>
                        }
                    </div>
                    <div className='d-flex align-items-center mb-5 border-bottom border-secondary'>
                        <span className='bullet bullet-vertical h-30px bg-success mb-1'></span>
                        <div className='flex-grow-1 mx-8 '>

                            <a href={currentPath} onClick={(e) => handleItemClick(e, 'active')} className='text-gray-800 text-hover-primary fw-bold fs-6'>
                                {"Active"}
                            </a>
                        </div>
                        <span className='fw-bold badge badge-primary d-block me-2'>{followup_active}</span>

                        {/* <a href={`${process.env.REACT_APP_HOME_PAGE}visafile-management/list?visafollowup=active&${filteredFilter}`} target='_blank' type='button' className='btn btn-sm btn-icon btn-color-success btn-active-light-success'>
                            <KTSVG path='/media/icons/duotune/general/gen057.svg' className='svg-icon-2' />
                        </a> */}
                        {
                            hasMatchingKey === true ?
                                <a href={`${process.env.REACT_APP_HOME_PAGE}visafile-management/list?${newFilteredFilter}&${name}=active`} target='_blank' type='button' className='btn btn-sm btn-icon btn-color-success btn-active-light-success'>
                                    <KTSVG path='/media/icons/duotune/general/gen057.svg' className='svg-icon-2' />
                                </a>
                                : <a href={`${process.env.REACT_APP_HOME_PAGE}visafile-management/list?${filteredFilter}&${name}=active`} target='_blank' type='button' className='btn btn-sm btn-icon btn-color-success btn-active-light-success'>
                                    <KTSVG path='/media/icons/duotune/general/gen057.svg' className='svg-icon-2' />
                                </a>
                        }
                    </div>
                    <div className='d-flex align-items-center mb-5 border-bottom border-secondary'>
                        <span className='bullet bullet-vertical h-30px bg-success mb-1'></span>
                        <div className='flex-grow-1 mx-8 '>

                            <a href={currentPath} onClick={(e) => handleItemClick(e, 'deactive')} className='text-gray-800 text-hover-primary fw-bold fs-6'>
                                {"Deactive"}
                            </a>
                        </div>
                        <span className='fw-bold badge badge-primary d-block me-2'>{followup_deactive}</span>

                        {/* <a href={`${process.env.REACT_APP_HOME_PAGE}visafile-management/list?visafollowup=deactive&${filteredFilter}`} target='_blank' type='button' className='btn btn-sm btn-icon btn-color-success btn-active-light-success'>
                            <KTSVG path='/media/icons/duotune/general/gen057.svg' className='svg-icon-2' />
                        </a> */}
                        {
                            hasMatchingKey === true ?
                                <a href={`${process.env.REACT_APP_HOME_PAGE}visafile-management/list?${newFilteredFilter}&${name}=deactive`} target='_blank' type='button' className='btn btn-sm btn-icon btn-color-success btn-active-light-success'>
                                    <KTSVG path='/media/icons/duotune/general/gen057.svg' className='svg-icon-2' />
                                </a>
                                : <a href={`${process.env.REACT_APP_HOME_PAGE}visafile-management/list?${filteredFilter}&${name}=deactive`} target='_blank' type='button' className='btn btn-sm btn-icon btn-color-success btn-active-light-success'>
                                    <KTSVG path='/media/icons/duotune/general/gen057.svg' className='svg-icon-2' />
                                </a>
                        }
                    </div>

                    <div className='d-flex align-items-center mb-5 border-bottom border-secondary'>
                        <span className='bullet bullet-vertical h-30px bg-success mb-1'></span>
                        <div className='flex-grow-1 mx-8 '>

                            <a href={currentPath} onClick={(e) => handleItemClick(e, 'past_active')} className='text-gray-800 text-hover-primary fw-bold fs-6'>
                                {"Past Active"}
                            </a>
                        </div>
                        <span className='fw-bold badge badge-primary d-block me-2'>{followup_past_active}</span>

                        {/* <a href={`${process.env.REACT_APP_HOME_PAGE}visafile-management/list?visafollowup=deactive&${filteredFilter}`} target='_blank' type='button' className='btn btn-sm btn-icon btn-color-success btn-active-light-success'>
                            <KTSVG path='/media/icons/duotune/general/gen057.svg' className='svg-icon-2' />
                        </a> */}
                        {
                            hasMatchingKey === true ?
                                <a href={`${process.env.REACT_APP_HOME_PAGE}visafile-management/list?${newFilteredFilter}&${name}=past_active`} target='_blank' type='button' className='btn btn-sm btn-icon btn-color-success btn-active-light-success'>
                                    <KTSVG path='/media/icons/duotune/general/gen057.svg' className='svg-icon-2' />
                                </a>
                                : <a href={`${process.env.REACT_APP_HOME_PAGE}visafile-management/list?${filteredFilter}&${name}=past_active`} target='_blank' type='button' className='btn btn-sm btn-icon btn-color-success btn-active-light-success'>
                                    <KTSVG path='/media/icons/duotune/general/gen057.svg' className='svg-icon-2' />
                                </a>
                        }
                    </div>

                    <div className='d-flex align-items-center mb-5 border-bottom border-secondary'>
                        <span className='bullet bullet-vertical h-30px bg-success mb-1'></span>
                        <div className='flex-grow-1 mx-8 '>

                            <a className='text-gray-800 text-hover-primary fw-bold fs-6'>
                                {"Today's Followup"}
                            </a>
                        </div>
                        <span className='fw-bold badge badge-primary d-block me-2'>{today_followup}</span>

                        <a href={`${process.env.REACT_APP_HOME_PAGE}clientfollowupdetail-management/list?${name}=todaysfollowup`} target='_blank' type='button' className='btn btn-sm btn-icon btn-color-success btn-active-light-success'>
                            <KTSVG path='/media/icons/duotune/general/gen057.svg' className='svg-icon-2' />
                        </a>
                        {/* {
                            hasMatchingKey === true ?
                                <a href={`${process.env.REACT_APP_HOME_PAGE}visafile-management/list?${newFilteredFilter}&${name}=todaysfollowup`} target='_blank' type='button' className='btn btn-sm btn-icon btn-color-success btn-active-light-success'>
                                    <KTSVG path='/media/icons/duotune/general/gen057.svg' className='svg-icon-2' />
                                </a>
                                : <a href={`${process.env.REACT_APP_HOME_PAGE}visafile-management/list?${filteredFilter}&${name}=todaysfollowup`} target='_blank' type='button' className='btn btn-sm btn-icon btn-color-success btn-active-light-success'>
                                    <KTSVG path='/media/icons/duotune/general/gen057.svg' className='svg-icon-2' />
                                </a>
                        } */}
                    </div>
                    <div className='d-flex align-items-center mb-5 border-bottom border-secondary'>
                        <span className='bullet bullet-vertical h-30px bg-success mb-1'></span>
                        <div className='flex-grow-1 mx-8 '>

                            <a className='text-gray-800 text-hover-primary fw-bold fs-6'>
                                {"Today's Task"}
                            </a>
                        </div>
                        <span className='fw-bold badge badge-primary d-block me-2'>{today_task}</span>

                        <a href={`${process.env.REACT_APP_HOME_PAGE}task-management/list?followup_option=todaystask`} target='_blank' type='button' className='btn btn-sm btn-icon btn-color-success btn-active-light-success'>
                            <KTSVG path='/media/icons/duotune/general/gen057.svg' className='svg-icon-2' />
                        </a>
                    </div>
                </div>

            </div>
        </div>
    )
}

export { VisaListFollowupRecord }
